import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { AuthApiService } from 'src/app/services/auth-api.service';
import { ApiEnvironmentBannerService } from 'src/app/services/api-environment-banner.service';
import { UserRole } from 'src/app/shared/models/users/user-role';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  private signingOut = false;
  @ViewChild('sidenav', { static: true }) sidenav: ElementRef;
  @ViewChild('minimiseMenuBtn', { static: true }) minimiseMenuBtn: ElementRef;
  @ViewChild('logoLarge', { static: true }) logoLarge: ElementRef;
  @ViewChild('logoSmall', { static: true }) logoSmall: ElementRef;

  showTextInHeader: boolean = false;
  headerText = 'Settings';
  userRoles: UserRole[] = [];
  showNav: boolean = true;
  environmentBanner: string | null = null;
  isProductionBanner = false;

  constructor(
    private router: Router,
    private authApi: AuthApiService,
    private apiEnvironmentBanner: ApiEnvironmentBannerService,
    public settingsService: SettingsService
  ) {}

  async ngOnInit() {
    if (window.innerWidth <= 1024) {
      this.toggleSideNav();
    }

    this.apiEnvironmentBanner.getBannerLabel().subscribe((label) => {
      this.environmentBanner = label;
      this.isProductionBanner = this.apiEnvironmentBanner.isProductionBanner(label);
    });

    if (localStorage.getItem('token')) {
      this.settingsService.ValidateGlobalVars().then(() => {
        this.userRoles = this.settingsService.userRoles;
      });
    }
  }

  ngDoCheck() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url === '/settings') {
          this.showTextInHeader = true;
          this.headerText = 'Settings';
        } else if (e.url === '/user-management') {
          this.showTextInHeader = true;
          this.headerText = 'Manage Users';
        } else if (e.url === '/trade-planning') {
          this.showTextInHeader = true;
          this.headerText = 'Arb Trade Planning';
        } else if (e.url === '/trade-docs') {
          this.showTextInHeader = true;
          this.headerText = 'Trade Docs';
        } else if (e.url === '/current-trades') {
          this.showTextInHeader = true;
          this.headerText = 'Current Trades';
        } else if (e.url === '/wealth-onboarding') {
          this.showTextInHeader = true;
          this.headerText = 'Wealth Management Onboarding';
        } else if (e.url === '/tools') {
          this.showTextInHeader = true;
          this.headerText = 'Tools';
        } else if (e.url === '/tools/workbench') {
          this.showTextInHeader = true;
          this.headerText = 'Workbench';
        } else if (e.url === '/tools/public-holidays') {
          this.showTextInHeader = true;
          this.headerText = 'Public Holidays';
        } else if (e.url === '/ait') {
          this.showTextInHeader = true;
          this.headerText = 'AIT Management';
        } else if (e.url === '/onboarding') {
          this.showTextInHeader = true;
          this.headerText = 'Onboarding';
        } else if (e.url === '/offboarding') {
          this.showTextInHeader = true;
          this.headerText = 'Offboarding';
        } else if (e.url === '/sql-reports') {
          this.showTextInHeader = true;
          this.headerText = 'Reporting';
        } else {
          this.showTextInHeader = this.settingsService.showTextInHeader;
          this.headerText = this.settingsService.headerText;
        }
      }
    });
  }

  menuClicked() {
    if (window.innerWidth <= 1024 && this.settingsService.sidenavExpanded) {
      this.toggleSideNav();
    }
  }

  toggleSideNav() {
    if (this.sidenav.nativeElement.className === 'side-nav fixed wide') {
      this.settingsService.sidenavExpanded = false;
      this.sidenav.nativeElement.className = 'side-nav fixed wide slim';
      this.minimiseMenuBtn.nativeElement.className = 'sv-slim-icon fas fa-angle-double-right';
      this.logoLarge.nativeElement.className = 'logo-wrapper waves-effect p-1 d-none';
      this.logoSmall.nativeElement.className = 'waves-effect p-1';
    } else {
      this.settingsService.sidenavExpanded = true;
      this.sidenav.nativeElement.className = 'side-nav fixed wide';
      this.minimiseMenuBtn.nativeElement.className = 'sv-slim-icon fas fa-angle-double-left';
      this.logoLarge.nativeElement.className = 'logo-wrapper waves-effect p-1';
      this.logoSmall.nativeElement.className = 'waves-effect p-1 d-none';
    }
  }

  Logout() {
    if (this.signingOut) {
      return;
    }
    this.signingOut = true;

    this.authApi.logout().subscribe({
      next: () => this.completeLogout(),
      error: () => this.completeLogout(),
    });
  }

  private completeLogout(): void {
    localStorage.clear();
    this.router.navigate(['']);
  }
}
